import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/help/navigation.png'
import _imports_1 from '@/assets/images/help/dashboards.png'
import _imports_2 from '@/assets/images/help/filter.png'
import _imports_3 from '@/assets/images/help/sort.png'
import _imports_4 from '@/assets/images/help/date_range.png'
import _imports_5 from '@/assets/images/help/utility_favorite.png'
import _imports_6 from '@/assets/images/help/favorites_modal.png'
import _imports_7 from '@/assets/images/help/navigation_favorites.png'
import _imports_8 from '@/assets/images/help/favorites.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/usingthesite",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Using the Site")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/dashboards",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dashboards")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/faqs",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "FAQs")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/changelog",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Change Log")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { id: "sidebar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Using the Site", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Sidebar Menu", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Sidebar Menu"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " You can navigate through the application using the sidebar menu. From this menu, you can return to the Home Screen, access Dashboards from the Dashboard Icon or see and select from a list of Favorite views. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { id: "home" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Home Screen", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Screenshot of dashboards available",
  class: "img-auto"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Transaction Dashboard:"),
  /*#__PURE__*/_createTextVNode(" Summary view of Quotes and Order. Provides Steelcase with a view of pending business for Direct Sell Customers. Provides the Dealer and Steelcase with order status information. ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Transaction Detail Dashboard:"),
  /*#__PURE__*/_createTextVNode(" Includes line detail and discrepancies between the Dealer's Hedberg System and Steelcase's SAP. ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reconciliation Dashboard:"),
  /*#__PURE__*/_createTextVNode(" View of potential mismatched order data between the Dealer's Hedberg System and Steelcase's SAP. An \"early warning system\" for mismatched transactions. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reconciliation Detail Dashboard:"),
  /*#__PURE__*/_createTextVNode(" Includes line detail and discrepancies between the Dealer's Hedberg System and Steelcase's SAP. ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Commission Dashboard:"),
  /*#__PURE__*/_createTextVNode(" View of detailed information regarding expected Direct Sell commissions, Direct Sell customer invoices and commission payments to dealers. ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Commission Detail Dashboard:"),
  /*#__PURE__*/_createTextVNode(" Includes line detail and discrepancies between the Dealer's Hedberg System and Steelcase's SAP. ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", { id: "filter" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Filter", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Filters",
  class: "img-auto"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " Each column has a filter icon that you can click on and either enter or select from the list. For example, you can filter to select a specific order number or to only see exceptions. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", { id: "sort" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, "Sort", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " A column can be sorted by clicking anywhere in the column header box. The first click will be a A to Z or low to high sort, the second click will be Z to A or high to low. ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Sort",
  class: "img-auto"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", { id: "date" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", null, "Date Range", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "pad-t-0" }, " Only orders with activity in the displayed date range will be included in the grid. Activity includes new orders entered, changes to orders or processing activities for the lines on the order. This includes activity in SAP and the Dealer’s Hedberg System. ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "The default date range is the current calendar year (01/01/2021 to 12/31/2021)", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Date Range modal window",
  class: "img-auto"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "pad-t-0" }, " To select a specific date range, click anywhere in the start date box and the calendar will appear. Navigate to and select the beginning of the date range, then navigate and select the end of the date range. The start and end dates will be populated, and the grid will refresh to include only orders in the selected range. ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "To remove the date range, click on the \"X\" next to the End date.", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", { id: "favorites" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h3", null, "Favorites", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Accessing Favorites",
  class: "img-auto"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, " Favorites allows you to name and save the grid with all the filters, sorting, etc. so it can be used again and again. ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " After you have customized the grid, select Favorites from the Options bar in the upper right. ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, " The Favorites Form pop-up window  will appear. Enter the name and click Save Favorite. Cancel will close the pop-up window without saving. ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Favorites Modal",
  class: "img-auto"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " Once saved, you can access your Favorites from the side-bar menu. Select the star icon. ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "Favorites Modal",
  class: "img-auto"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, " The list of Favorites will appear. You will see the name and the Dashboard to which it applies. Click on the name and the grid will refresh to reflect the customizations saved. ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "Managing Favorites",
  class: "img-auto"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "pad-v-20"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _hoisted_5,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 3 }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 21 }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_10,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider),
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_19,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider),
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_23,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider),
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 20 }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_27,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider),
              _hoisted_28
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 16 }, {
            default: _withCtx(() => [
              _hoisted_29,
              _hoisted_30
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_32,
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 })
        ]),
        _: 1
      }),
      _hoisted_34,
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider),
              _hoisted_35
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}